import {NetworkOutreachDetails, NetworkOutreachDetailsProps} from "./NetworkOutreachDetails";
import { OutreachExportType } from "../export/enumerations";

const PractitionerAtLocation: React.FC<React.PropsWithChildren<NetworkOutreachDetailsProps>> = (props:NetworkOutreachDetailsProps) => {
  return (
    <NetworkOutreachDetails {...props} name="Practitioner At Location" exportType={ OutreachExportType.PractitionerAtLocation } />
  )
}

export default PractitionerAtLocation;